import React from "react";
import Axios from "axios";
import { baseUrl } from "../../config";
import FormOriginal from "./form";
function Create(props) {
  const handleSubmit = (e, form) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        Axios.post(baseUrl + "user/", {
          email: values.email,
          password: values.password,
          firstName: values.firstName,
          lastName: values.lastName,
          admin: values.admin,
        }).then((response) => console.log(response));
      }
    });
  };

  return <FormOriginal handleSubmit={handleSubmit} type="Create" />;
}

export default Create;
